import { useEffect, useRef } from "react";
import Header from "@/components/hotel/Header";
import Footer from "@/components/hotel/Footer";
import SubpageHero from "@/components/hotel/SubpageHero";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const localeMap: Record<string, string> = {
  de: "de",
  en: "en",
  fr: "fr",
  es: "es",
  it: "it",
};

const BookingPage = () => {
  const { language, t } = useLanguage();
  const containerRef = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.cubilis.eu/js/ratebox.bundle.js";
    script.type = "text/javascript";
    script.onload = () => {
      if (!initializedRef.current && (window as any).Ratebox) {
        new (window as any).Ratebox({
          IBEUrl: "esos-hotel-quelle-switzerland",
          key: "fbb6837a-2f6c-4ba9-ab03-4d4206a0b632",
          locale: localeMap[language] || "en",
        });
        initializedRef.current = true;
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [language]);

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Jetzt buchen"
        description="Buchen Sie Ihr Zimmer oder Apartment im ESOS Hotel Quelle Bad Ragaz – direkt und zum besten Preis."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Buchen", path: "/booking" },
        ]}
      />
      <Header />
      <SubpageHero title={t.nav.bookNow} subtitle="" />
      <section className="hotel-section bg-background">
        <div className="hotel-container">
          <div ref={containerRef} id="ratebox-container" className="min-h-[600px]" />
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default BookingPage;
